import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import arrowsDownUpIcon from '../Icons/arrows-down-up.svg';

const DashboardTableTitle = (props) => {
  return (
    <div className='dashboard-table-title'>
      <div className='dashboard-table-row-data' onClick={() => props.reorderRows()}>
        תאריך שליחה <Image src={arrowsDownUpIcon} />
      </div>
      <div className='dashboard-table-row-customer'> שם מנוי</div>
      <div className='dashboard-table-row-idNumber'>ת.ז מנוי</div>
      <div className='dashboard-table-row-phone'>מספר מנוי</div>
      <div className='dashboard-table-row-action-type'>סוג העברת בעלות</div>
      <div className='dashboard-table-row-performed-by'>בוצע על ידי</div>
      <div className='dashboard-table-row-equipment'>חיובי ציוד</div>
      <div className='dashboard-table-row-status'>בדיקת סטטוס ופעולות</div>
    </div>
  );
};
export default DashboardTableTitle;
